module.exports = __webpack_public_path__ + "static/LucasPope0-2de33a7832a06a0cc5f109a5a9831854.webp";